import React, { useEffect, useState } from "react";
import "./PodcastUploadStatus.css";
import { graphql, useLazyLoadQuery } from "react-relay";

const QUERY = graphql`
  query PodcastUploadStatusQuery {
    recentPodcastUploads {
      id
      title
      taskResult {
        dateCreated
      }
      taskStateSummary
    }
  }
`;

export default function PodcastUploadStatus(props) {
  const [refresh, setRefresh] = useState(0);
  const [stopRefresh, setStopRefresh] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (!stopRefresh) {
        setRefresh(refresh + 1);
      }
    }, 5 * 1000); // 10 seconds
  }, [refresh]);

  const data = useLazyLoadQuery(
    QUERY,
    {},
    { fetchKey: refresh, fetchPolicy: "network-only" }
  );

  useEffect(() => {
    if (data.recentPodcastUploads.length === 0) {
      setStopRefresh(true);
    }
  }, [refresh]);

  return (
    <div className="podcast-upload-status-container">
      <h2>Podcast Upload Status</h2>
      {data.recentPodcastUploads.map((podcastUpload) => {
        return (
          <div
            key={podcastUpload.id}
            className={`podcast-upload-status-entry podcast-upload-${podcastUpload.taskStateSummary.toLowerCase()}`}
          >
            {podcastUpload.title} - {podcastUpload.taskStateSummary}
          </div>
        );
      })}

      {data.recentPodcastUploads.length === 0 ? (
        <p>No podcast uploads in last hour.</p>
      ) : null}
    </div>
  );
}
